module.exports = __webpack_public_path__ + "img/sld_mfm_invs_1_dark.c2944183.svg";